import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=78b5565e&scoped=true"
import script from "./Terminos.vue?vue&type=script&lang=js"
export * from "./Terminos.vue?vue&type=script&lang=js"
import style0 from "./Terminos.vue?vue&type=style&index=0&id=78b5565e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5565e",
  null
  
)

export default component.exports